export const CLINIC_STEP_NAMEList = [
  "0상",
  // "1/2상",
  // "1/2a상",
  // "1/3상",
  "1상",
  // "1b상",
  // "2/3상",
  "2상",
  // "2a상",
  // "2b/3상",
  // "2b상",
  // "3/4상",
  "3상",
  // "3a상",
  // "3b상",
  "4상",
  // "생동",
  "연구자 임상시험",
  "연장",
];

export const paletteCollection = [
  "Material",
  "Soft Pastel",
  "Harmony Light",
  "Pastel",
  "Bright",
  "Soft",
  "Ocean",
  "Office",
  "Vintage",
  "Violet",
  "Carmine",
  "Dark Moon",
  "Soft Blue",
  "Dark Violet",
  "Green Mist",
];
export const paletteExtensionModes = ["Alternate", "Blend", "Extrapolate"];
